"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");












































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      devieTypeList: [], // 设备类型下拉列表
      newadd: false, newadd2: false, title: '', searchData: { id: '', canUpgrade: '', deviceTypeId: '', otaVersion: '', sn: '', deviceID: '', // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', otaVersion: '', enabled: '1', isForce: '0', md5: 'fffffffffffffffffffffffffffff007', path: 'ota/version/1571882081585', urlList: ['123'], remark: '', firmwareType: '3', // 固件类型1中心板2wifi板3讯飞WiFi板4非讯飞WiFi板
        firmwareDownloadType: '1', deviceTypeId: '1', url: '', url2: '' }, defaultData: { id: '', otaVersion: '', enabled: '1', isForce: '0', md5: 'fffffffffffffffffffffffffffff007', path: 'ota/version/1571882081585', urlList: ['123'], remark: '', firmwareType: '3', // 固件类型1中心板2wifi板3讯飞WiFi板4非讯飞WiFi板
        firmwareDownloadType: '1', deviceTypeId: '1', url: '', url2: '' }, rules: { otaVersion: [{ required: true, message: '请输入固件版本', trigger: 'blur' }], isForce: [{ required: true, message: '请选择是否强制升级', trigger: 'blur' }], enabled: [{ required: true, message: '请选择是否启用', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'sn', label: '设备ID', width: 180, isShow: true }, { prop: 'deviceTypeName', label: '设备类型', isShow: true }, { prop: 'otaVersion', label: '语音版本', isShow: true }, { prop: 'canUpgrade', label: '是否允许升级', formatter: _formatter.upgradeFormatter, isShow: true }, { prop: 'operatorName', label: '操作人', isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'operatorName', label: '创建者', isShow: true }] };
  },
  mounted: function mounted() {
    var self = this;
    self.init();
    self.getDeviceTypeList();
  },
  methods: {
    init: function init() {
      var self = this;
      self.getData('/api/faOtaVersionStatus/', self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    checkPermission: _user.checkPermission,
    resetFun: function resetFun() {// 重置
      this.searchData.sn = '';
      this.searchData.otaVersion = '';
      this.searchData.deviceTypeId = '';
      this.searchData.canUpgrade = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    handleSelectionChange: function handleSelectionChange(val) {var _this = this;
      var self = this;
      self.deviceIds = '';
      val.map(function (item) {
        _this.deviceIds += item.id + ',';
      });
    },
    getDeviceTypeList: function getDeviceTypeList() {
      var self = this;
      self.getData('/api/faDeviceType', {
        rows: 100 },
      function (res) {
        self.devieTypeList = res.list;
      });
    },
    auditFun: function auditFun(item, type) {
      var self = this;
      var idses = item.id;
      if (item.canUpgrade === 1) {
        self.searchData.deviceID = '0';
      } else if (item.canUpgrade === 0) {
        self.searchData.deviceID = '1';
      }
      self.$confirm('确定修改该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.postData('/api/faOtaVersionStatus/updateCanUpgrade/' + self.searchData.deviceID, [idses], function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          item.canUpgrade = type;
          self.init();
        });
      }).catch(function () {});
    },
    batchUpgradeFun: function batchUpgradeFun(item, type) {
      var self = this;
      var idses = self.deviceIds.substr(0, self.deviceIds.length - 1).split(',');
      var idList = idses.map(function (el) {
        return parseInt(el);
      });
      if (idses === '') {
        this.$message({
          showClose: true,
          message: '请选择要升级的数据',
          type: 'error' });

      } else if (idses !== '') {
        self.$confirm('确定修改该记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true }).
        then(function () {
          self.postData('/api/faOtaVersionStatus/updateCanUpgrade/1', idList, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            item.enabled = type;
            self.init();
          });
        }).catch(function () {});
      }
    },
    batchNoUpgradeFun: function batchNoUpgradeFun(item, type) {
      var self = this;
      var idses = self.deviceIds.substr(0, self.deviceIds.length - 1).split(',');
      var idList = idses.map(function (el) {
        return parseInt(el);
      });
      if (idses === '') {
        this.$message({
          showClose: true,
          message: '请选择不升级的数据',
          type: 'error' });

      } else if (idses !== '') {
        self.$confirm('确定修改该记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true }).
        then(function () {
          self.postData('/api/faOtaVersionStatus/updateCanUpgrade/0', idList, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            item.enabled = type;
            self.init();
          });
        }).catch(function () {});
      }
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();
      this.cleanData();
      this.newadd = false;
      this.newadd2 = false;
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faOtaVersion', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        enabled: '',
        isForce: '',
        firmwareDownloadType: '',
        otaVersion: '',
        remark: '',
        firmwareType: '3',
        md5: '',
        url2: '',
        path: '' };

    } } };exports.default = _default;